import TreeCheckboxComponent from "../treeview/tree-checkbox.component";
import ViewBase from "../../views/view-base.view";
import { Button, Dialog, Icon, Icons, Intent } from "construct-ui";
import loginModel from "../../models/login.model";
import siteModel from "../../models/site/site.model";

export default function LocationTreeCheckboxComponent() {
  ViewBase.call(this);

  const TITLE_SEPARATOR = ', ';

  let isOpenLocationSelect = false;
  let locationList = [];
  let locationMap = {};
  let selectedLocationCodeList = [];
  let selectedChildCodeList = [];
  let required = false;
  let onChangeCallback = (selectedParents, selectedChildren) => { };
  let onChange = (selectedParents, selectedChildren) => {
    selectedChildCodeList = selectedChildren;
    onChangeCallback(selectedParents, selectedChildren);
  };

  let sortLocations = (a, b) => {
    // Sort by Level, Parent, Name
    return a.level - b.level || a.parentCode.localeCompare(b.parentCode) || a.name.localeCompare(b.name)
  }

  let restructureLocationList = (flatList = []) => {
    const hashTable = {};
    const treeList = [];

    // Sort
    flatList.sort(sortLocations);

    flatList.forEach(flatItem => {
      hashTable[flatItem.code] = { ...flatItem, children: [] }
      locationMap[flatItem.code] = flatItem;
    });

    flatList.forEach(flatItem => {
      try {
        if (flatItem.parentCode && hashTable[flatItem.parentCode]) {
          hashTable[flatItem.parentCode].children.push(hashTable[flatItem.code]);
        } else {
          treeList.push(hashTable[flatItem.code]);
        }
      } catch (error) {
        // Unexpected error
        console.error(error)
      }
    });

    return treeList;
  }

  let getLocationList = () => {
    locationList = [];
    locationMap = {};

    return siteModel.getByType({ type: 'location', countryCode: loginModel.credentials.country })
      .then((result) => {
        locationList = restructureLocationList(result);
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let renderLabel = () => {
    return (selectedLocationCodeList && selectedLocationCodeList.length > 0)
      ? selectedLocationCodeList.length + ' ' + this.getText("LT00000308", "item(s) selected")
      : ''
  }

  const renderTitle = () => {
    return (selectedLocationCodeList && selectedLocationCodeList.length > 0 && Object.keys(locationMap).length > 0)
      ? selectedLocationCodeList.map(locationCode => locationMap[locationCode].name).join(TITLE_SEPARATOR)
      : ''
  }

  const readOnly = (event) => {
    event.preventDefault();
    event.stopImmediatePropogation();
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.required === 'boolean') {
        required = vnode.attrs.required;
      }
      if (vnode.attrs.onChange) {
        onChangeCallback = vnode.attrs.onChange;
      }
      if (vnode.attrs.selectedCodes) {
        selectedLocationCodeList = vnode.attrs.selectedCodes;
      }
      getLocationList();
    },
    onupdate: (vnode) => {
      if (vnode.attrs.selectedCodes) {
        selectedLocationCodeList = vnode.attrs.selectedCodes;
      }
    },
    view: (vnode) => {
      if (vnode.attrs.selectedCodes) {
        selectedLocationCodeList = vnode.attrs.selectedCodes;
      }
      return [
        m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
          class: vnode.attrs.disabled ? 'disabled ' : '',
          onclick: () => {
            if (!vnode.attrs.disabled) {
              isOpenLocationSelect = !isOpenLocationSelect;
            }
          }
        },
          m('input.flex-fill.text-start.ps-0', {
            id: vnode.attrs.id,
            disabled: vnode.attrs.disabled,
            required,
            type: 'text',
            placeholder: vnode.attrs.placeholder || this.getText("LT00000201", "Please select"),
            oninput: readOnly,
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            value: renderLabel(),
            title: renderTitle()
          }),
          m(Icon, { name: Icons.MAP_PIN, intent: Intent.PRIMARY })
        ),
        isOpenLocationSelect &&
        m(Dialog, {
          class: 'cui-dialog-l',
          closeOnOutsideClick: false,
          isOpen: isOpenLocationSelect,
          onClose: () => isOpenLocationSelect = false,
          title: this.getText("LT00000555", "Location Selection"),
          content: m('.container', { style: "height: 560px;" },
            m(TreeCheckboxComponent, {
              data: locationList,
              selectedCodes: selectedLocationCodeList,
              isLevel1Expanded: vnode.attrs.isLevel1Expanded === true,
              onChange: onChange,
            })
          ),
          footer: [
            m('.d-flex.justify-content-end',
              m(Button, {
                label: this.getText("LT00000021", "Close"),
                intent: Intent.PRIMARY,
                onclick: () => { isOpenLocationSelect = false },
              })
            )
          ]
        }),
        this.getBaseViews()
      ]
    }
  }
}
